var map = {
	"./action-nav.ru.json": 139,
	"./articles-list.ru.json": 141,
	"./articles/ru/belt-and-route.ru.json": 150,
	"./articles/ru/biodiversity.ru.json": 151,
	"./articles/ru/economic-mistakes.ru.json": 152,
	"./articles/ru/law.ru.json": 153,
	"./articles/ru/negative-economics.ru.json": 154,
	"./articles/ru/protected-areas.ru.json": 155,
	"./articles/ru/public-opinion.ru.json": 156,
	"./articles/ru/similar-stories-2.ru.json": 157,
	"./articles/ru/similar-stories.ru.json": 158,
	"./articles/ru/xrays.ru.json": 159,
	"./film.ru.json": 161,
	"./footer.ru.json": 163,
	"./hero-unit.ru.json": 165,
	"./media-publications.ru.json": 167,
	"./pages/ru/about.ru.json": 174,
	"./pages/ru/e40.ru.json": 175,
	"./pages/ru/expertise.ru.json": 176,
	"./pages/ru/petition.ru.json": 177,
	"./pages/ru/position.ru.json": 178,
	"./pages/ru/press-kit.ru.json": 179,
	"./problem-description.ru.json": 181,
	"./social-feeds.ru.json": 183,
	"./timeline.ru.json": 185,
	"./top-nav.ru.json": 187
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 137;


//////////////////
// WEBPACK FOOTER
// ./src/assets/content ^\.\/.*\.ru\.json$
// module id = 137
// module chunks = 0